import '.d2{font-size:1.125rem;}.ssr-plugin'
import '.fj{line-height:1.75rem;}.ssr-plugin'
import '.bl{text-decoration:none;}.ssr-plugin'
import '.dq{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="d2 fj"
    >
      {translations.privacySubtitle}{' '}
      <a className="bl dq"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="bl dq"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
